import { useRef } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Actions from './actions';
import ChatBox from './ChatBox';
import ChatWithModals from './ChatWithModals';
import Header from './header';
import useCopilotChatContext from '../hooks/useCopilotChatContext';
import { ChatDataProvider } from '../contexts/ChatDataContext';

const HEADER_HEIGHT = '60px';

const FusionCopilotContent = () => {
	const { messages } = useCopilotChatContext();
	const chatBoxRef = useRef<HTMLDivElement>(null);
	const scrollContainerRef = useRef<HTMLDivElement>(null);

	return (
		<ChatWithModals>
			<Flex ref={chatBoxRef} h="full" direction="column" overflow="hidden">
				{/* Sticky header for mobile - hidden on desktop */}
				<Box display={{ base: 'block', md: 'none' }} flexShrink={0}>
					<Header height={HEADER_HEIGHT} />
				</Box>

				{/* Chat messages - scrollable area */}
				<Box
					ref={scrollContainerRef}
					flex="1"
					overflow="auto"
					position="relative"
					sx={{
						// Prevent iOS bounce scroll from interfering with our scroll detection
						WebkitOverflowScrolling: 'touch',
						// Ensure smooth scrolling on mobile
						scrollBehavior: 'smooth',
					}}
				>
					<ChatBox messages={messages} scrollContainerRef={scrollContainerRef} />
				</Box>

				{/* Actions - sticky at bottom */}
				<Box flexShrink={0}>
					<Actions />
				</Box>
			</Flex>
		</ChatWithModals>
	);
};

const FusionCopilot = () => {
	return (
		<ChatDataProvider>
			<FusionCopilotContent />
		</ChatDataProvider>
	);
};

export default FusionCopilot;
